import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToArticles, type NewsListType } from "@/_pages/news/model";

import { searchParams } from "./params";

/** Подгрузка следующих страниц листинга блога */
export const getCurrentBlogPosts = async (
  _filter: string,
  pageCount: number,
): Promise<NewsListType> => {
  const posts = strapiClient.collection("blog-posts");

  const list = await posts.find({
    ...searchParams.posts,
    pagination: {
      ...searchParams.posts.pagination,
      page: pageCount || 1,
    },
  });

  return rebuild(mapDtoToArticles(list)) as NewsListType;
};
